exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,\nbody {\n  margin: 0;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n}\n\nbody * {\n  -webkit-overflow-scrolling: touch;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n}\n\nbutton {\n  cursor: pointer;\n}\n\np {\n  margin: 0;\n}\n\ninput {\n  font-size: 16px;\n}\n\ng {\n  outline: 0;\n}\n\ninput:focus {\n  outline: none;\n  border-style: solid;\n  border-color: rgb(72, 146, 211);\n}\n", ""]);

// exports
